<template>
  <v-container fluid style="padding: 0; padding-right: 0">
    <v-row
      dense
      v-if="(!all || all_add) && !isReplyList && canAdd"
      style="padding-bottom: 10px; padding-top: 5px"
    >
      <div style="flex-basis: 35px; padding: 0 5px">
        <v-avatar
          size="36"
          :style="{
            color: $loginState.user.text_colour,
            backgroundColor: $loginState.user.background_colour,
          }"
        >
          <span class="primary-avatar">{{ userInitials() }}</span>
        </v-avatar>
      </div>
      <template v-if="!all">
        <div style="flex-basis: calc(100% - 120px)">
          <MentionEditor
            :value="comment.text"
            :items="availableUsers"
            @input="commentEdited(comment, $event)"
            :testid="testid"
          ></MentionEditor>
        </div>
        <div style="flex-basis: 70px; padding-left: 5px; padding-top: 5px">
          <v-progress-circular
            v-if="isLoading && activeAction === 'save_new'"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn
            v-else
            small
            color="primary"
            :disabled="!comment.isDirty"
            @click="handler('save_new')"
            v-testid="testid + 'save-new'"
            >Send</v-btn
          >
        </div>
      </template>
      <template v-else>
        <div style="flex-basis: calc(100% - 55px)" v-if="!isLoading">
          <MentionEditor
            :value="comment.text"
            :items="availableUsers"
            showSave
            @input="commentEdited(comment, $event)"
            @cancel="commentEditCancelled(comment)"
            @save="handler('save_new', comment)"
            :testid="testid"
          ></MentionEditor>
        </div>
        <v-progress-circular
          v-else-if="activeAction === 'save_new'"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </template>
    </v-row>
    <v-row
      dense
      v-for="(cm, cmi) in commentList.filter((x) => x.visible)"
      :key="'cm' + cmi"
      :class="isReplyList ? 'my-0' : 'my-2'"
    >
      <div style="flex-basis: 35px; padding: 0 5px">
        <v-avatar
          :style="{
            color: cm.text_colour,
            backgroundColor: cm.background_colour,
          }"
          :size="!isReplyList ? 36 : 24"
        >
          <span :class="isReplyList ? 'reply-avatar' : 'primary-avatar'">{{
            cm.user_initials
          }}</span>
        </v-avatar>
      </div>
      <div :style="{ flexBasis: `calc(100% - ${isReplyList ? 40 : 55}px)` }">
        <div
          :class="all ? 'view-comment-container' : 'view-comment-container-old'"
          @mouseover="hoverCommentIndex = cmi"
          @mouseout="hoverCommentIndex = -1"
        >
          <template v-if="!cm.editInProgress">
            <span :class="all ? 'view-comment-user' : 'view-comment-user-old'">{{
              cm.user_name
            }}</span>
            <span
              v-if="cm.role"
              :class="all ? 'view-comment-role' : 'doc-role'"
              >{{ cm.role }}</span
            >
            <v-tooltip bottom v-if="cm.not_visible_to">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="amber" class="ml-1" v-bind="attrs" v-on="on"
                  >mdi-alert</v-icon
                >
              </template>
              <div>
                <h4>
                  Warning: Current Document Status means this Comment cannot be
                  viewed by:
                </h4>
                <br />
                <ul>
                  <li
                    v-for="(u, ui) in cm.not_visible_to.split('|')"
                    :key="'u' + ui"
                  >
                    {{ u }}
                  </li>
                </ul>
                <br />
                <span
                  >(users will be notified once the document transitions to a
                  relevant status)</span
                >
              </div>
            </v-tooltip>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small class="float-right mr-2"
                  >mdi-dots-horizontal
                </v-icon>
              </template>
              <v-list dense>
                <v-list-item
                  v-if="
                    canAdd &&
                    cm.replies.length === 0 &&
                    cm.created_by === $loginState.user.user_id
                  "
                  @click="cm.editInProgress = true; cm.editIsDirty = false;"
                  v-testid="testid + 'start-edit' + cmi"
                >
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="canAdd" @click.stop="showReply(cm)"
                  v-testid="testid + 'reply' + cmi">
                  <v-list-item-title>Reply</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="showResolving && canAdd" @click.stop="resolveComment(cm)"
                  v-testid="testid + 'resolve' + cmi">
                  <v-list-item-title>{{
                    cm.resolved ? "Unresolve" : "Resolve"
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="
                    canAdd &&
                    cm.replies.length === 0 &&
                    cm.created_by === $loginState.user.user_id
                  "
                  @click.stop="showRemoveComment(cm)"
                  v-testid="testid + 'delete' + cmi"
                >
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-tooltip bottom v-if="showResolving && (canAdd || cm.resolved)">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-if="canAdd"
                  @click="resolveComment(cm)"
                  v-bind="attrs"
                  v-on="on"
                  class="float-right mr-2"
                  :color="cm.resolved ? '#48A401' : '#AAAAAA'"
                  :style="`${
                    hoverCommentIndex === cmi || cm.resolved
                      ? ''
                      : 'visibility: hidden'
                  }`"
                  small
                  v-testid="testid + 'resolve_' + cmi"
                  >mdi-check</v-icon
                >
                <v-icon
                  v-else
                  v-bind="attrs"
                  v-on="on"
                  class="float-right mr-2"
                  color="#48A401"
                  small
                  >mdi-check</v-icon
                >
              </template>
              <div>
                Click to mark as {{ cm.resolved ? "unresolved" : "resolved" }}
                <span v-if="cm.resolved_by">
                  <v-divider /><br />
                  Set to {{ cm.resolved ? "Resolved" : "Unresolved" }} by
                  {{ cm.resolved_by }} {{ cm.resolved_date }}
                </span>
                <span v-else-if="cm.resolved"
                  ><v-divider /><br />
                  Set to Resolved just now
                </span>
              </div>
            </v-tooltip>
            <v-icon
              v-if="canAdd"
              @click="showReply(cm)" title="Reply"
              class="float-right mr-2"
              :color="cm.reply.show ? '#48A401' : '#AAAAAA'"
              :style="`${
                hoverCommentIndex === cmi || cm.reply.show
                  ? ''
                  : 'visibility: hidden'
              }`"
              small
              v-testid="testid + 'show-reply' + cmi"
              >mdi-reply</v-icon
            >
            <br />
            <span v-html="cm.comment" class="view-comment-text"></span>
          </template>
          <MentionEditor v-else
            :value="cm.comment"
            :items="availableUsers"
            @input="commentEdited(cm, $event)"
            placeholder="Your edit..."
            showSave
            @save="handler('save_edit', cm)"
            @cancel="commentEditCancelled(cm)"
            v-testid="testid + 'editor'"
          ></MentionEditor>
        </div>
        <div v-if="all" class="comment-timestamp">
          {{ cm.created_date_alt }}
        </div>
        <div
          v-else
          title="Reply"
          style="font-size: 12px; font-weight: bold"
          class="d-flex align-center"
        >
          <v-btn
            v-if="canAdd"
            small
            text
            @click="showReply(cm)"
            style="opacity: 0.7; font-weight: bold"
            v-testid="testid + '-show-reply' + cmi"
            >Reply</v-btn
          >
          <span style="margin-left: 15px" :title="cm.created_date">{{
            cm.elapsed_time
          }}</span>
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              canAdd &&
              cm.replies.length === 0 &&
              cm.created_by === $loginState.user.user_id
            "
            @click="showRemoveComment(cm)"
            text
            small
            style="opacity: 0.7; font-weight: bold"
            v-testid="testid + 'remove-comment' + cmi"
          >
            Remove
          </v-btn>
        </div>
        <div
          v-if="cm.reply.show"
          dense
          style="display: flex; padding-top: 5px; padding-bottom: 10px"
        >
          <div style="flex-basis: 35px; padding-top: 5px">
            <v-avatar
              size="24"
              :style="{
                color: $loginState.user.text_colour,
                backgroundColor: $loginState.user.background_colour,
              }"
            >
              <span class="reply-avatar">{{ userInitials() }}</span>
            </v-avatar>
          </div>
          <template v-if="!all">
            <div style="flex-basis: calc(100% - 115px)">
              <MentionEditor
                :value="cm.reply.text"
                :items="availableUsers"
                @input="commentEdited(cm.reply, $event)"
                placeholder="Add your reply..."
                @save="handler('save_new_reply', cm)"
                @cancel="commentEditCancelled(cm)"
                v-testid="testid + 'reply-edit'"
              ></MentionEditor>
            </div>
            <div style="flex-basis: 70px; padding-left: 5px; padding-top: 5px">
              <v-progress-circular
                v-if="isLoading && activeAction === 'save_new_reply'"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <v-btn
                v-else
                small
                color="primary"
                :disabled="!cm.reply.isDirty"
                @click="handler('save_new_reply', cm)"
                v-testid="testid + 'save-edit' + cmi"
                >Send</v-btn
              >
            </div>
          </template>
          <template v-else>
            <div style="flex-basis: 100%" v-if="!isLoading">
              <MentionEditor
                :value="cm.reply.text"
                :items="availableUsers"
                showSave
                @input="commentEdited(cm.reply, $event)"
                placeholder="Add your reply..."
                :setFocusTrigger="cm.reply.setFocusTrigger"
                @save="handler('save_new_reply', cm)"
                @cancel="commentEditCancelled(cm)"
                :testid="testid + 'reply-edit'"
              ></MentionEditor>
            </div>
            <v-progress-circular
              v-else-if="activeAction === 'save_new_reply'"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </template>
        </div>
        <div style="padding-top: 5px" v-if="cm.replies.length">
          <DocumentComments
            :document="document"
            :commentList="cm.replies"
            :doc_part_id="doc_part_id"
            :all="all"
            :availableUsers="availableUsers"
            isReplyList
            @saved="saved"
            @commentResolved="(e) => $emit('commentResolved', e)"
            :testid="testid + '_' + cmi + '_'"
          ></DocumentComments>
        </div>
      </div>
    </v-row>
    <!-- <v-row dense v-if="commentList.some(x => !x.visible)">
      <div class="show-hidden"
        @click="showHiddenComments()">Show {{ commentList.filter(x => !x.visible).length }} resolved comment{{commentList.filter(x => !x.visible).length > 1 ? 's' : ''}}</div>
    </v-row> -->
    <v-dialog v-model="removeComment.show" max-width="600px">
      <v-card>
        <v-card-title class="justify-right">
          Confirm
          <v-spacer></v-spacer>
          <v-btn icon class="btn-background" @click="removeComment.show = false"
            v-testid="testid + 'confirm-close'"
            ><v-icon>close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text class="pb-0">
          <p>Permanently remove comment ?</p>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-btn color="primary" outlined @click="removeComment.show = false"
            v-testid="testid + 'confirm-cancel'"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>

          <v-progress-circular
            v-if="isLoading && activeAction === 'remove'"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn
            v-else
            class="error"
            @click="handler('remove', removeComment.comment)"
            v-testid="testid + 'confirm-remove'"
            >Remove</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
// import ResponseHandler from "@/components/ResponseHandler"; // @ is an alias to /src
import MentionEditor from "../comments/MentionEditor.vue";
import utils from "@/common/utils.js";

export default {
  name: "DocumentComments",
  components: {
    // ResponseHandler,
    MentionEditor,
  },
  props: {
    document: null,
    partType: null,
    doc_part_id: null,
    dpa_tag_id: null,
    commentList: null,
    isReplyList: Boolean,
    all: Boolean,
    all_add: Boolean,
    showResolving: Boolean,
    availableUsers: [],
    testid: String,
  },
  data: function () {
    return {
      title: "",
      comment: {
        dp_id: null,
        dpa_tag_id: null,
        text: "",
        dirtyText: "",
        isDirty: false,
        action: null,
        mentions: [],
      },
      response: null,
      isLoading: false,
      canAdd: false,
      utils: utils,
      removeComment: {
        comment: null,
        show: false,
      },
      activeAction: "",
      hoverCommentIndex: -1,
    };
  },
  updated() {},
  created() {
    if (this.document) {
      this.handler("show");
    }
  },
  watch: {
    // commentList(newval) {
    //   if (newval?.doc_part_id !== this.dp_id) this.handler("show");
    // },
  },
  methods: {
    saved(data) {
      this.$emit("saved", data);
    },
    docPartCommentAction() {
      return this.document.state ? this.document.state.docPartCommentAction : this.document.commentActions?.find(x => x.isComment);
    },
    docCommentAction() {
      return this.document.state ? this.document.state.docCommentAction : this.document.commentActions?.find(x => x.isDocumentComment);
    },
    handler(action, item) {
      this.activeAction = action;
      let saveRespHandler = (data) => {
        if (data) {
          if (item && item.reply?.show) {
            item.reply.text = "";
            item.reply.isDirty = false;
            item.reply.show = false;
          } else {
            this.resetComment();
          }
          if (action === "remove" && item.dp_id) {
            data.removed_dp_id = item.dp_id;
          }
          this.saved(data);
        }
        this.activeAction = "";
      };
      switch (action) {
        case "show":
          this.title = `${this.partType || "Document"} Comments`;
          this.resetComment();
          // this.getUserList();
          this.comment.dp_id = this.doc_part_id;
          this.comment.dpa_tag_id = this.dpa_tag_id;
          this.canAdd =
            this.doc_part_id ?
            !!this.docPartCommentAction() :
              !!this.docCommentAction();
          break;
        case "save_new":
          this.comment.text = this.comment.dirtyText.trim();
          if (this.comment.text.length) {
            this.saveComment(
              this.doc_part_id
                ? this.docPartCommentAction()
                : this.docCommentAction(),
              false,
              saveRespHandler,
              this.comment
            );
          }
          break;
        case "save_edit":
          item.text = item.dirtyText.trim();
          if (item.text.length) {
            this.saveComment(
              this.doc_part_id
                ? this.docPartCommentAction()
                : this.docCommentAction(),
              false,
              saveRespHandler,
              { ...item }
            );
          }
          break;
        case "save_new_reply":
          item.reply.text = item.reply.dirtyText;
          this.saveComment(
            this.doc_part_id
              ? this.docPartCommentAction()
              : this.docCommentAction(),
            false,
            saveRespHandler,
            item.reply
          );
          break;
        case "remove":
          this.saveComment(
            this.doc_part_id
              ? this.docPartCommentAction()
              : this.docCommentAction(),
            false,
            saveRespHandler,
            { ...item, remove: true }
          );
          break;
      }
    },
    resetComment() {
      this.comment.text = "";
      this.comment.isDirty = false;
    },
    saveComment(action, savedata, callback, comment) {
      if (!this.document) return;
      this.isLoading = true;
      let request = {
        doc_id: this.document.doc_id,
        action_available_id: action.action_available_id,
        lifecycle_role_id: action.lifecycle_role_id,
        document_role_id: action.document_role_id,
        preProcessResponse: null,
        comment: comment,
      };
      if (savedata) {
        request.preProcessResponse = this.dataCapture.value;
      }
      axios
        .post("document/processdocumentaction/", request)
        .then((resp) => {
          if (resp.data.Status === "OK") {
            if (callback) {
              callback(resp.data.Data);
            }
          } else {
            alert(resp.data.Message);
          }
          this.isLoading = false;
          this.removeComment.show = false;
          this.response = resp.data;
          this.$store.dispatch("docs/updateCommentCount", {
            doc_id: this.document.doc_id,
            action: comment.remove ? "remove" : "add",
          });
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            console.log(err);
            this.response = err.response
              ? err.response.data
              : { message: "Unexpected Error" };
          }
          this.removeComment.show = false;
          this.isLoading = false;
        });
    },
    resolveComment(comment) {
      if (!this.document || !this.showResolving) return;
      this.isLoading = true;
      let request = {
        doc_id: this.document.doc_id,
        document_comment_id: comment.document_comment_id,
        dp_id: comment.dp_id,
        resolved: comment.resolved === 1 ? 0 : 1,
      };
      comment.resolved = request.resolved;
      this.$emit("commentResolved", request);
    },
    userInitials() {
      return this.$loginState.user.name
        .split(" ")
        .map((x) => x.substr(0, 1))
        .join("");
    },
    showReply(cm) {
      cm.reply.show = !cm.reply.show;
      if (cm.reply.show) {
        this.$nextTick(() => {
          cm.reply.setFocusTrigger++;
        });
      }
    },
    showRemoveComment(cm) {
      this.removeComment.comment = cm;
      this.removeComment.show = true;
    },
    commentEdited(item, data) {
      item.dirtyText = data.content;
      item.mentions = data.mentions;
      item.isDirty = true;
    },
    commentEditCancelled(item) {
      item.dirtyText = "";
      item.mentions = [];
      item.isDirty = false;
      item.editInProgress = false;
      if (item.reply) item.reply.show = false;
      this.$emit('cancelEdit');
    },
    showHiddenComments() {
      this.commentList.forEach((x) => (x.visible = !x.visible));
    },
  },
};
</script>
<style scoped>
.doc-role {
  font-size: 11px;
  border: 1px solid green;
  margin-left: 10px;
  border-radius: 3px;
  padding: 0 5px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.view-comment-text {
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0%;
  line-height: 100%;
  color: #000000e4;
}
.view-comment-container-old {
  border: solid #cfd8dc 1px;
  background-color: #eceff1;
  border-radius: 5px;
  padding: 3px;
}
.view-comment-container {
  font-family: "DM Sans";
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #dddddd;
  padding: 8px 12px;
  padding-top: 4px;
}
.view-comment-user-old {
  font-size: 11px;
  font-weight: bolder;
}
.view-comment-user {
  font-family: "DM Sans";
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0%;
  line-height: 100%;
  color: #000000;
}
.view-comment-role {
  font-family: "DM Sans";
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0%;
  line-height: 100%;

  color: #000000;
  background-color: #eeeeee;
  height: 18px;
  vertical-align: middle;
  border-radius: 4px;
  padding: 0 4px;
  margin-left: 4px;
}
.comment-timestamp {
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0%;
  line-height: 100%;
  color: #000000;
  padding-left: 12px;
  padding-top: 2px;
  margin-bottom: 4px;
}
.primary-avatar {
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0%;
}
.reply-avatar {
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0%;
}
.show-hidden {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0%;
  padding: 8px;
  padding-left: 12px;
  cursor: pointer;
}
</style>
